import React from "react";
import Link from "next/link";
import { ChevronRightIcon, HomeIcon } from "@heroicons/react/20/solid";

type BreadcrumbLink = {
  name: string;
  href: string;
  current?: boolean;
};

export function Breadcrumb({
  links,
  space = true,
  className,
}: {
  links: BreadcrumbLink[];
  space?: boolean;
  className?: string;
}) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`w-full ${space ? "flex mb-2 md:mb-4 -mt-3" : "flex -mt-3"} ${className}`}>
      <ol role="list" className="rounded py-2 flex items-center space-x-1">
        <li>
          <Link href="/">
            <HomeIcon
              className="h-4 w-4 flex-shrink-0 text-secondary hover:text-primary"
              aria-hidden="true"
            />
          </Link>
        </li>
        {links?.map((link) => {
          return link.current ? (
            <li key={link.name}>
              <div className="flex items-center">
                <ChevronRightIcon
                  className="h-4 w-4 mr-1 flex-shrink-0 text-secondary"
                  aria-hidden="true"
                />
                <Link
                  href={link.href}
                  className="text-sm capitalize text-ellipsis font-normal text-gray-400 cursor-default line-clamp-1">
                  {link.name}
                </Link>
              </div>
            </li>
          ) : (
            <li key={link.name}>
              <div className="flex items-center">
                <ChevronRightIcon
                  className="h-4 w-4 mr-1 flex-shrink-0 text-secondary"
                  aria-hidden="true"
                />
                <Link
                  href={link.href}
                  className="text-sm font-semibold text-ellipsis text-secondary hover:underline line-clamp-1">
                  {link.name}
                </Link>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
